"use client";
import { jsxs as o, jsx as e, Fragment as b } from "react/jsx-runtime";
import { useState as M, useId as T, useRef as S, useEffect as $ } from "react";
import { cn as r } from "../utils/cn.js";
import { N3wthProvider as Y } from "../theme/N3wthProvider.js";
import { n3wthTheme as _ } from "../theme/n3wthTheme.js";
import { useRouteScrollReset as ee } from "../hooks/useRouteScrollReset.js";
import { ReadingOutline as ne } from "./ReadingOutline.js";
import { Heading as H } from "../packages/ui/node_modules/@astryxdesign/core/dist/Heading/Heading.js";
import { Text as O } from "../packages/ui/node_modules/@astryxdesign/core/dist/Text/Text.js";
function R({ as: t = "div", className: n, ...i }) {
  return /* @__PURE__ */ e(t, { className: r("n3wth-site-container", n), ...i });
}
function G({ className: t, ...n }) {
  return /* @__PURE__ */ e("section", { className: r("n3wth-site-section", t), ...n });
}
function W({ className: t, ...n }) {
  return /* @__PURE__ */ e("nav", { className: r("n3wth-site-section-links", t), ...n });
}
const F = { page: 1, section: 2, item: 3 };
function L({ variant: t = "section", level: n, className: i, children: s, ...a }) {
  return /* @__PURE__ */ e(H, { level: n ?? F[t], className: r("n3wth-site-heading", `n3wth-site-heading--${t}`, i), ...a, children: s });
}
function I({ variant: t = "body", as: n = "p", className: i, children: s, ...a }) {
  return /* @__PURE__ */ e(O, { as: n, type: t === "lede" ? "body" : t, display: n === "span" ? "inline" : "block", className: r("n3wth-site-text", `n3wth-site-text--${t}`, i), ...a, children: s });
}
function z({ title: t, level: n = 2, className: i, children: s, ...a }) {
  return /* @__PURE__ */ o("div", { className: r("n3wth-site-doc-section", i), ...a, children: [
    t != null ? /* @__PURE__ */ e(L, { variant: "section", level: n, children: t }) : null,
    s
  ] });
}
function J({ items: t, className: n, ...i }) {
  return /* @__PURE__ */ e("ul", { className: r("n3wth-site-doc-list", n), ...i, children: t.map((s, a) => /* @__PURE__ */ e("li", { children: s }, a)) });
}
function K({ title: t, level: n = 1, description: i, actions: s, aside: a, align: d = "start", spacing: u = "default", className: c, ...f }) {
  return /* @__PURE__ */ o("header", { className: r("n3wth-site-page-header", a != null && "n3wth-site-page-header--split", d === "center" && "n3wth-site-page-header--center", u === "compact" && "n3wth-site-page-header--compact", c), ...f, children: [
    /* @__PURE__ */ o("div", { className: "n3wth-site-page-header-copy", children: [
      /* @__PURE__ */ e(L, { variant: n === 1 ? "page" : "section", level: n, children: t }),
      i != null && /* @__PURE__ */ e(I, { className: "n3wth-site-description", children: i }),
      s != null && /* @__PURE__ */ e("div", { className: "n3wth-site-actions", children: s })
    ] }),
    a != null && /* @__PURE__ */ e("div", { className: "n3wth-site-page-header-aside", children: a })
  ] });
}
function Q({ brand: t, links: n, actions: i, navigationLabel: s = "Primary", navigationId: a, menuLabel: d = "Open menu", menuContent: u, collapseAt: c = "md", className: f, ...C }) {
  const [m, l] = M(!1), E = T(), g = a ?? `site-navigation-${E}`, N = S(null), p = S(null), w = u != null;
  return $(() => {
    if (!m) return;
    p.current?.querySelector(w ? ".n3wth-site-navigation-menu a" : ".n3wth-site-navigation-links a")?.focus();
    const h = window.matchMedia(`(min-width: ${c === "lg" ? 1024 : 768}px)`), k = () => {
      h.matches && l(!1);
    }, x = (v) => {
      p.current?.contains(v.target) || l(!1);
    }, y = (v) => {
      v.key === "Escape" && (l(!1), N.current?.focus());
    };
    return document.addEventListener("pointerdown", x), document.addEventListener("keydown", y), h.addEventListener("change", k), () => {
      document.removeEventListener("pointerdown", x), document.removeEventListener("keydown", y), h.removeEventListener("change", k);
    };
  }, [m, c, w]), /* @__PURE__ */ e("header", { ...C, ref: p, className: r("n3wth-site-navigation", `n3wth-site-navigation--${c}`, f), children: /* @__PURE__ */ o("div", { className: "n3wth-site-navigation-island", "data-nosnippet": !0, children: [
    /* @__PURE__ */ e("div", { className: "n3wth-site-navigation-brand", onClick: () => l(!1), children: t }),
    /* @__PURE__ */ e("nav", { id: g, "aria-label": s, className: "n3wth-site-navigation-links", "data-open": m, onClick: (h) => {
      h.target.closest("a") && l(!1);
    }, children: w ? /* @__PURE__ */ o(b, { children: [
      /* @__PURE__ */ e("div", { className: "n3wth-site-navigation-inline", children: n }),
      /* @__PURE__ */ e("div", { className: "n3wth-site-navigation-menu", children: u })
    ] }) : n }),
    /* @__PURE__ */ e("div", { className: "n3wth-site-navigation-actions", onClick: () => l(!1), children: i }),
    /* @__PURE__ */ e("button", { ref: N, type: "button", className: "n3wth-site-navigation-toggle", "aria-label": m ? "Close menu" : d, "aria-controls": g, "aria-expanded": m, onClick: () => l((h) => !h), children: /* @__PURE__ */ e("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", "aria-hidden": "true", children: m ? /* @__PURE__ */ e("path", { d: "m6 6 12 12M6 18 18 6" }) : /* @__PURE__ */ e("path", { d: "M4 6h16M4 12h16M4 18h16" }) }) })
  ] }) });
}
function U({ brand: t = /* @__PURE__ */ e("a", { href: "https://n3wth.com", children: "Oliver Newth" }), links: n, sourceHref: i = "https://github.com/n3wth/n3wth", legalLinks: s, children: a, className: d, ...u }) {
  const c = n ?? /* @__PURE__ */ o(b, { children: [
    /* @__PURE__ */ e("a", { href: "https://n3wth.com/library", children: "Library" }),
    /* @__PURE__ */ e("a", { href: "https://n3wth.com/contact", children: "Contact" }),
    /* @__PURE__ */ e("a", { href: i, children: "GitHub" }),
    s
  ] });
  return /* @__PURE__ */ e("footer", { ...u, className: r("n3wth-site-footer", d), children: /* @__PURE__ */ o(R, { "data-nosnippet": !0, children: [
    /* @__PURE__ */ o("div", { className: "n3wth-site-footer-row", children: [
      t != null && /* @__PURE__ */ e("div", { className: "n3wth-site-footer-brand", children: t }),
      /* @__PURE__ */ e("nav", { "aria-label": "Footer", className: "n3wth-site-footer-links", children: c })
    ] }),
    a != null && /* @__PURE__ */ e("div", { className: "n3wth-site-footer-meta", children: a })
  ] }) });
}
export {
  Y as N3wthProvider,
  K as PageHeader,
  ne as ReadingOutline,
  R as SiteContainer,
  J as SiteDocList,
  z as SiteDocSection,
  U as SiteFooter,
  L as SiteHeading,
  Q as SiteNavigation,
  G as SiteSection,
  W as SiteSectionLinks,
  I as SiteText,
  _ as n3wthTheme,
  ee as useRouteScrollReset
};
//# sourceMappingURL=index.js.map
